import { Controller } from "@hotwired/stimulus"
import Plyr from "plyr"

export default class extends Controller {
  static targets = ["video"]
  static values = { url: String }

  connect() {
    this.videoTarget.addEventListener("contextmenu", e => e.preventDefault())
    this.loadVideo()
  }

  disconnect() {
    if (this.player) {
      this.player.destroy()
    }
  }

  async loadVideo() {
    try {
      const response = await fetch(this.urlValue, {
        headers: { "Accept": "application/json" }
      })

      if (!response.ok) return

      const data = await response.json()
      const video = this.videoTarget
      video.src = data.url
      video.load()

      this.player = new Plyr(video, {
        controls: [
          "play-large",
          "play",
          "progress",
          "current-time",
          "mute",
          "volume",
          "settings",
          "fullscreen"
        ],
        disableContextMenu: true
      })

      this.player.on("ended", () => this.onEnded())
    } catch (e) {
      // silently fail - video area stays empty
    }
  }

  onEnded() {
    // Video finished - could auto-mark complete or show next lesson prompt
  }
}
